export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto text-center">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-4">
          联系我们 · 投稿合作
        </h2>
        <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
          欢迎漫画作者、汉化组、版权方与我们合作。无论是作品投稿、版权合作还是广告投放，妖精动漫网期待与您携手共创优质漫画阅读生态。读者反馈和建议也将帮助我们不断进步。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="flex items-center gap-2 px-6 py-3 bg-background-100 rounded-xl">
            <i className="ri-mail-line text-primary-500 text-lg"></i>
            <span className="text-foreground-700 text-sm">contact@yaojingdm.com</span>
          </div>
          <div className="flex items-center gap-2 px-6 py-3 bg-background-100 rounded-xl">
            <i className="ri-wechat-line text-accent-500 text-lg"></i>
            <span className="text-foreground-700 text-sm">微信公众号：妖精动漫</span>
          </div>
          <div className="flex items-center gap-2 px-6 py-3 bg-background-100 rounded-xl">
            <i className="ri-bilibili-line text-secondary-500 text-lg"></i>
            <span className="text-foreground-700 text-sm">B站：妖精动漫网官方</span>
          </div>
        </div>
      </div>
    </section>
  );
}